export const newRelicConstants = {
  // ad types
  STANDARD_BANNER: 'sponsoredStandardBanner',
  LEADERBOARD_BANNER: 'sponsoredLeaderboardBanner',
  SKYSCRAPER_BANNER: 'sponsoredSkyscraperBanner',
  PIP_BANNER: 'sponsoredPipBanner',
  PIP_PLA: 'sponsoredPipPla',
  CAROUSEL_PLA: 'sponsoredBottomCarousel',
  HERO_BANNER: 'sponsoredHeroBanner',
  NON_ENDEMIC_BANNER: 'nonEndemicBanner',
  CAROUSEL_SEO: 'sponsoredPipsemCarousel',
  PRODUCT_LISTING_AD: 'sponsoredProductListingAd',

  // event types
  LOAD: 'load',
  IMPRESSION: 'impression',
  CLICK: 'click',
  AD_BLOCKED: 'adblocker_enabled',

  // latency tracking
  STANDARD_BANNER_API_RESPONSE: 'sponsored-banner.time-until-api-response',
  STANDARD_BANNER_AD_LOAD: 'sponsored-banner.time-until-ad-load',
  NON_ENDEMIC_BANNER_REQUEST: 'nonendemic-banner.time-until-requested'
};
export const newRelicDataTestId = {
  'sponsored-standard-banner': newRelicConstants.STANDARD_BANNER,
  'sponsored-skyscraper-banner': newRelicConstants.SKYSCRAPER_BANNER,
  'sponsored-leaderboard-banner': newRelicConstants.LEADERBOARD_BANNER,
  'sponsored-product-pod': newRelicConstants.CAROUSEL_PLA,
  'sponsored-hero-banner': newRelicConstants.HERO_BANNER,
  'sponsored-pip-banner': newRelicConstants.PIP_BANNER,
  'sponsored-product-listing': newRelicConstants.PRODUCT_LISTING_AD,
};
